const { gte, lt } = require("../utils/version")
const { isWebView } = require("../utils/platform")
const { exceptionHandler } = require("../utils")
const { getCookie } = require("../utils/cookie")
const { IDENTITY, DEFAULT_VERSION, DEFAULT_SUPPORT_VERSIONS } = require("../constants")

/**
 * native defined interface method callbacks (AppCallbacks)
 * @callback AppCallbacks
 */

/**
 * callback handler for native defined methods
 * @param {AppCallbacks} cb - native defined callback
 * @param {object} [support] - support version object
 */
const callbackHandler = (cb, support = DEFAULT_SUPPORT_VERSIONS) => {
    if (isWebView()) {
        const identityConfig = getCookie(IDENTITY.CONFIG)
        if (identityConfig) {
            const platform = identityConfig.platform
            const platformVersion = identityConfig.version
            const isDefaultSupportVersion = support[platform] === DEFAULT_VERSION
            const supportVersion = isDefaultSupportVersion
                ? identityConfig.support[platform]
                : support[platform]
            if (gte(platformVersion, supportVersion)) {
                typeof cb === "function" && exceptionHandler(cb())
            }
        }
    }
}

/**
 * @typedef CallbackObject
 * @type {object}
 * @property {AppCallbacks} current - current interface callback
 * @property {AppCallbacks} legacy - legacy interface callback
 */

/**
 * callback handler for current and legacy based native interface callbacks
 * legacy identification is based on <synapse:legacy> cookie, and the version support object
 * @param {CallbackObject} cbObj - native interface callback object
 * @param {object} [support] - version support object
 */
const legacyHandler = (cbObj, support = DEFAULT_SUPPORT_VERSIONS) => {
    if (isWebView()) {
        const { legacy, current } = cbObj || {}
        const identityConfig = getCookie(IDENTITY.CONFIG)
        const legacyFallback = getCookie(IDENTITY.LEGACY)
        if (identityConfig) {
            const platform = identityConfig.platform
            const platformVersion = identityConfig.version
            const isDefaultSupportVersion = support[platform] === DEFAULT_VERSION
            const supportVersion = isDefaultSupportVersion
                ? identityConfig.support[platform]
                : support[platform]
            if (legacyFallback || lt(platformVersion, supportVersion)) {
                typeof legacy === "function" && exceptionHandler(legacy())
            } else {
                typeof current === "function" && exceptionHandler(current())
            }
        }
    }
}

module.exports = { callbackHandler, legacyHandler }
